import*as React from"react";import styled from"@emotion/styled";import{QuestionHeaderContainer,QuestionLabel,QuestionDescription}from"../../../onboarding/atoms";import Modal from"@wp/src/components/common/modal";import{mediaQuery}from"@wp/src/components/common/grid";export const PreferenceQuestionContainer=styled.div`
  padding: 4px 8px;
`;export const PreferenceQuestionHeader=props=>{return React.createElement(QuestionHeaderContainer,{itemsSpacingVertical:8},React.createElement(QuestionLabel,null,props.question.question),React.createElement(QuestionDescription,null,props.question.placeholder))};export const StyledPreferencePopup=styled(Modal)`
  ${mediaQuery({width:["100% !important","90vw !important"]})}

  .ant-modal-close {
    top: 8px;
    inset-inline-end: 8px;
  }
`;